import { randomId } from "@mantine/hooks";
import { Fragment, useCallback } from "react";
import { ReviewText } from "src/components/pages/Summary/ReviewsTable/ReviewsTable.styled";
import { DateTimeDisp } from "src/components/shared/DateTime";
import { type ISummaryItem } from "src/pages/Summary/Summary.types";
import { useSelector } from "src/redux/hooks";
import { StyledTd } from "src/styled";

import { handleRoles } from "../SummaryItemRow.utils";

interface Props {
  row: ISummaryItem;
  disabled: boolean | undefined;
  red?: boolean;
}

const RolesCells = ({ row, disabled, red }: Props) => {
  const { rolename: role, medroles } = useSelector(state => state.permsSlice);
  const userRoles = [...(medroles ?? []), role];
  const renderRoles = useCallback(
    (type: "pri" | "sec") => {
      const { roles, option, color, date } = handleRoles(row, type, userRoles);
      const blue = color === "blue";
      const red = color === "red";
      const green = color === "green";
      // eslint-disable-next-line react-hooks/exhaustive-deps -- reassigning the disabled param here is local to this call; kept as is
      disabled = color === "gray" || disabled;

      return (
        <>
          {date && (
            <DateTimeDisp
              size="13px"
              utc={(type === "pri" ? row.primaryUTC : row.secondaryUTC) ?? ""}
              utcOffset={row.datecreatedOffset}
              lt={(type === "pri" ? row.primarydate : row.secondarydate) ?? ""}
              disabled={disabled}
              color={color}
              containerProps={{ mb: 4 }}
            />
          )}

          {roles.map((role, i) => (
            <ReviewText
              key={randomId()}
              fz="13px"
              blue={blue}
              red={red}
              green={green}
              disabled={disabled}>
              {i === 0 && option ? option + " " + role : role}
            </ReviewText>
          ))}
        </>
      );
    },
    [disabled, row],
  );
  return (
    <Fragment>
      <StyledTd red={red}>{renderRoles("pri")}</StyledTd>
      <StyledTd red={red}>{renderRoles("sec")}</StyledTd>
    </Fragment>
  );
};
export default RolesCells;
